/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminVendorFieldMappingProfileService {

    /**
     * Get data loader history for a vendor field mapping profile
     * @returns any Success
     * @throws ApiError
     */
    public static getVendorFieldMappingProfileLoaders({
        id,
    }: {
        id: string,
    }): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/vendorFieldMappingProfile/{id}/loaders',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
